<template>
  <v-card outlined class="pa-4 font-weight-bold">
    <v-card-title class="font-weight-bold">Efficiency</v-card-title>
    <HorizontalBar :chartData="chartData" :options="options"></HorizontalBar>
  </v-card>
</template>

<script>
export default {
  name: "EfficiencyBarChart",
  components: {
    HorizontalBar: () => import("@/components/chart/HorizontalBar"),
  },
  computed: {
    chartData() {
      return this.$store.getters.promoOverviewHorizontalBarChartROIData;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    options() {
      const gridlines_color = this.$vuetify.theme.dark
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.1)";
      const fontColor = this.$vuetify.theme.themes[this.theme].chartFont;
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor: fontColor,
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                color: gridlines_color,
                zeroLineColor: gridlines_color,
              },
              ticks: {
                min: 0,
                fontColor: fontColor,
                callback: function(value) {
                  return `${value * 100}%`;
                },
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                color: gridlines_color,
                zeroLineColor: gridlines_color,
              },
              ticks: {
                fontColor: fontColor,
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem) {
              return (tooltipItem.xLabel * 100).toFixed(0) + "%";
            },
          },
        },
      };
    },
  },
};
</script>

<style scoped></style>
